import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=467550fd"
import script from "./HeaderComponent.ts?vue&type=script&lang=js&external"
export * from "./HeaderComponent.ts?vue&type=script&lang=js&external"
import style0 from "./Header.vue?vue&type=style&index=0&id=467550fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports